import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import config from 'react-global-configuration';
import queryString from 'query-string';
import './style.scss';

var ContextualActionsButtons = function ContextualActionsButtons(_ref) {
  var entityType = _ref.entityType,
      entityId = _ref.entityId,
      children = _ref.children;
  var API_URL = config.get('API_URL');
  var permissions = useSelector(function (state) {
    return state.getIn(['ui', 'permissions']);
  });
  var editUrl;

  switch (entityType) {
    case 'node':
      if (permissions.includes('administer nodes')) {
        editUrl = "".concat(API_URL, "/node/").concat(entityId, "/edit");
      }

      break;

    case 'user':
      if (permissions.includes('administer users')) {
        editUrl = "".concat(API_URL, "/user/").concat(entityId, "/edit");
      }

      break;

    case 'taxonomy_term':
      if (permissions.includes('administer taxonomy')) {
        editUrl = "".concat(API_URL, "/taxonomy/term/").concat(entityId, "/edit");
      }

      break;

    default:
      break;
  }

  if (!editUrl) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "ContextualActionsButtons"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ContextualActionsButtons__actions"
  }, /*#__PURE__*/React.createElement("a", {
    href: queryString.stringifyUrl({
      url: editUrl,
      query: {
        destination: window.location.href
      }
    })
  }, "Edit")), children);
};

export default ContextualActionsButtons;